module.exports = __webpack_public_path__ + "7720acf2b425e4ebaad297a5c47a40c1.MP3";